var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isHaveItem)?_c('ProductPointItem',{attrs:{"lbl":_vm.lbl,"pointProduct":_vm.listProduct,"activeTab":_vm.activeTab}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }